export default "__VITE_ASSET__DI0Q73$j__"